import React from "react";
import { ItemCategoryRead, ItemSubCategory } from "store/abcoApi";
import { Box, Button, Text, View } from "components/ui";
import CategoryCard from "./Card/CategoryCard";
import { useWindowDimensions } from "react-native";
import { useBreakpointValue } from "@gluestack-style/react";
import Pagination from "components/navigation/Pagination";
import { PageButton } from "components/page/parts/PageButton";
import { Link } from "expo-router";
type CategoryCardListProps = {
	list?: ItemCategoryRead[] | ItemSubCategory[] | null;
	withPagination?: boolean;
};

export default function CategoryCardList({ list, withPagination }: CategoryCardListProps) {
	const { width: windowWidth } = useWindowDimensions();
	const [pageNumber, setPageNumber] = React.useState(1);

	// Number of columns based on screen size
	const noColumn = useBreakpointValue({
		base: 2,
		lg: 4,
	});
	const itemWidth = useBreakpointValue({
		base: "$1/2",
		lg: "$1/4",
		md: "$1/3",
	});
	const itemsPerPage = noColumn * 2;

	const pageCount = Math.ceil(list ? list.length : 1 / itemsPerPage);
	let currentPageItems = null;
	const onChangePage = (newPage: number) => {
		setPageNumber(newPage);
	};
	if (list) {
		currentPageItems = list.slice((pageNumber - 1) * itemsPerPage, pageNumber * itemsPerPage);
	}

	// Assume each CategoryCard has a fixed height, for example, 426px
	const itemHeight = 426;
	const gap = 8;
	const numberOfRows = Math.ceil(currentPageItems ? currentPageItems.length : 1 / noColumn);
	const totalGapSpace = (numberOfRows - 1) * gap;
	const dynamicHeight = numberOfRows * itemHeight + totalGapSpace;

	if (withPagination) {
		return (
			<Box>
				<Box
					// height={"$full"}
					width="$full"
					sx={{
						width: "100%",
						flexDirection: "row",
						flexWrap: "wrap",
					}}
				>
					{currentPageItems &&
						currentPageItems.map((item: any, index) => {
							return (
								<Box key={index} width={itemWidth}>
									<CategoryCard category={item} />
								</Box>
							);
						})}
				</Box>
			</Box>
		);
	}
	return (
		<Box>
			<Box
				// height={"$full"}
				width="$full"
				sx={{
					width: "100%",
					flexDirection: "row",
					flexWrap: "wrap",
				}}
			>
				{list &&
					list.map((item: any, index) => {
						return (
							<Box key={index} width={itemWidth}>
								<CategoryCard category={item} />
							</Box>
						);
					})}
			</Box>
		</Box>
	);
}
